<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card class="pcard pcard--orange">
      <div class="pcard-header">
        <div class="pcard-header-left">
          <div class="pcard-icon-wrap" style="background:rgba(255,255,255,0.18)">
            <v-icon color="white" size="22">mdi-crosshairs-gps</v-icon>
          </div>
          <div>
            <p class="pcard-header-sub" style="color:rgba(255,255,255,0.9)!important">{{ $t('sidebar.live') }}</p>
            <h2 class="pcard-header-title" style="color:#fff!important">{{ $t('sidebar.live_tracking') }}</h2>
          </div>
        </div>
      </div>
      <v-card-text>
        <!-- Pa lidhje nuk mund te mberrije asnje pozicion i ri: tregohet
             qarte se cfare po shihet, qe te mos merret si levizje e tanishme. -->
        <v-alert
          v-if="offline"
          dense
          text
          type="warning"
          class="mb-3"
          icon="mdi-wifi-off"
        >
          <strong>{{ $t('live.offline_title') }}</strong>
          <div class="text-caption">
            {{ $t('live.offline_note') }}
            <span v-if="lastSync"> {{ $t('live.last_seen') }} {{ $moment(lastSync).format('HH:mm') }}</span>
          </div>
        </v-alert>

        <!--        <div class="row">-->
        <div class="tracking-div">
          <!--          <div class="col-md-8">-->
          <div class="tracking-map">
            <div class="tile-selector">
              <button v-for="s in tileStyles" :key="s.key" class="tile-btn"
                :class="{ active: tileStyle === s.key }" @click="tileStyle = s.key">{{ s.label }}</button>
            </div>
            <l-map
              style="height: 350px; border-radius: 14px; overflow: hidden;"
              :zoom="zoom"
              :center="center"
              ref="mymap"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <!--              <l-marker :lat-lng="markerLatLng">-->
              <!--                <l-tooltip>Hello!</l-tooltip>-->
              <!--              </l-marker>-->
              <l-marker
                v-for="(location, index) in busesLocation"
                :key="location.ride.id"
                :lat-lng="ankora(location)"
                :ref="`location-${location.ride.id}`"
              >
                <l-icon
                  :icon-size="busIconSize(busLabel(location))"
                  :icon-anchor="busIconAnchor(busLabel(location))"
                  :icon-url="busIcon(location.ride && location.ride.bus_id, busLabel(location))"
                ></l-icon>
                <l-tooltip>
                  Bus:
                  <span v-if="location.ride.bus">
                    {{ location.ride.bus.name }}
                  </span>
                  <br />
                  <div
                    v-for="student in location.ride.bus.students"
                    :key="student.id"
                  >
                    Student:
                    {{ student.name }}
                    <br />
                  </div>
                  Started At:
                  <span v-if="location.ride.started_at">
                    {{ location.ride.started_at | moment('DD/MM/YYYY HH:mm') }}
                  </span>
                  <span v-else>-</span>
                  <br />
                  Finished At:
                  <span v-if="location.ride.finished_at">
                    {{ location.ride.finished_at | moment('DD/MM/YYYY HH:mm') }}
                  </span>
                  <span v-else>-</span>
                </l-tooltip>
              </l-marker>
            </l-map>
            <div class="my-2">
              <div v-for="location in busesLocation" :key="location.ride.id">
                <v-btn
                  dark
                  color="primary"
                  type="button"
                  class="mx-2"
                  @click="goToCenterLocation(location.coordinates)"
                >
                  Center&nbsp;
                  <span v-if="location.ride.bus">
                    {{ location.ride.bus.name }}
                  </span>
                </v-btn>
              </div>
            </div>
          </div>
          <!--          <div class="col-md-4">-->
          <div class="tracking-rides">
            <v-select
              v-model="student_id"
              :items="students"
              item-text="name"
              item-value="id"
              clearable
              dense
              outlined
              label="Students"
            ></v-select>
            <div
              style="padding-block: 10px; max-height: 600px"
              class="scroll"
            >
              <div
                class="ride-card mb-3"
                v-for="element in rides"
                :key="element.id"
              >
                <!-- Bus name row -->
                <div class="ride-card-header">
                  <div class="ride-card-icon ride-icon-orange">
                    <v-icon size="18" color="#e65100">mdi-bus</v-icon>
                  </div>
                  <span class="ride-card-bus-name" v-if="element.ride && element.ride.bus">
                    {{ element.ride.bus.name }}
                  </span>
                  <span class="ride-card-bus-name" v-else>—</span>
                </div>
                <!-- Student row -->
                <div class="ride-card-row" v-if="element.student">
                  <div class="ride-card-icon ride-icon-blue">
                    <v-icon size="16" color="#1976D2">mdi-badge-account-outline</v-icon>
                  </div>
                  <span class="ride-card-text">{{ element.student.name }}</span>
                </div>
                <!-- Start time -->
                <div class="ride-card-row" v-if="element.started_at">
                  <div class="ride-card-icon ride-icon-green">
                    <v-icon size="16" color="#388E3C">mdi-clock-start</v-icon>
                  </div>
                  <span class="ride-card-text ride-card-text--muted">
                    {{ element.started_at | moment('DD/MM/YYYY') }}
                    <strong>{{ element.started_at | moment('HH:mm') }}</strong>
                  </span>
                </div>
                <!-- End time -->
                <div class="ride-card-row" v-if="element.finished_at">
                  <div class="ride-card-icon ride-icon-teal">
                    <v-icon size="16" color="#00838F">mdi-clock-end</v-icon>
                  </div>
                  <span class="ride-card-text ride-card-text--muted">
                    {{ element.finished_at | moment('DD/MM/YYYY') }}
                    <strong>{{ element.finished_at | moment('HH:mm') }}</strong>
                  </span>
                </div>
                <!-- Rejected -->
                <div class="ride-card-row" v-if="element.rejected_at">
                  <div class="ride-card-icon ride-icon-red">
                    <v-icon size="16" color="#D32F2F">mdi-alpha-x-circle-outline</v-icon>
                  </div>
                  <span class="ride-card-text" style="color:#D32F2F">
                    {{ element.rejected_at | moment('DD/MM/YYYY HH:mm') }} — Rejected
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="row">-->
        <!--          <div-->
        <!--            v-if="on_route_trips.length === 0"-->
        <!--            class="col-md-4 text-center py-10"-->
        <!--          >-->
        <!--            <v-icon size="100" class="py-10">mdi-bus-alert</v-icon>-->
        <!--            <h3>No on-route trips</h3>-->
        <!--          </div>-->
        <!--          <div v-else class="col-md-4">-->
        <!--            <div-->
        <!--              class="list-group-item py-6 my-2"-->
        <!--              :class="selectedIdx == index ? 'active-stop' : ''"-->
        <!--              v-for="(element, index) in on_route_trips"-->
        <!--              :key="element.id"-->
        <!--              @click="-->
        <!--                selectedItem = element.channel;-->
        <!--                selectedIdx = index;-->
        <!--              "-->
        <!--            >-->
        <!--              <div v-if="element.driver" class="d-flex align-center">-->
        <!--                <v-icon size="30" class="mr-2">mdi-bus</v-icon>-->
        <!--                <div class="font-weight-bold text-dark m-1 my-1">-->
        <!--                  {{ element.driver.name }}-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div-->
        <!--                class="text-dark m-1 my-1 ml-1"-->
        <!--                v-if="element.trip && element.trip.route"-->
        <!--              >-->
        <!--                <v-icon size="25" class="mr-2">mdi-road-variant</v-icon>-->
        <!--                {{ element.trip.route.name }}-->
        <!--              </div>-->
        <!--              <div class="text-dark m-1 my-1 ml-1">-->
        <!--                <v-icon size="25" class="mr-2"-->
        <!--                  >mdi-clock-time-four-outline</v-icon-->
        <!--                >-->
        <!--                {{ element.started_at }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="col-md-8" id="map">-->
        <!--            <GoogleMapLoader-->
        <!--              :enabled="false"-->
        <!--              :center="center"-->
        <!--              :selected="selectedItem"-->
        <!--              :zoom="zoom"-->
        <!--              :apiKey="apiKey"-->
        <!--              :markers="markers"-->
        <!--              :polylines="polyline"-->
        <!--            >-->
        <!--            </GoogleMapLoader>-->
        <!--          </div>-->
        <!--        </div>-->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// $(window).scroll(function () {
//   $("#map")
//     .stop()
//     .animate(
//       {
//         marginTop: $(window).scrollTop() + "px",
//         marginLeft: $(window).scrollLeft() + "px",
//       },
//       "slow"
//     );
// });

import GoogleMapLoader from '../../components/GoogleMapLoader.vue';
import { mesazhiIGabimit } from '@/utils/error-message';

import VueElementLoading from 'vue-element-loading';
// Levizja e autobusit midis dy pozicioneve, qe te mos kerceje.
import { glideTo } from '@/utils/marker-glide';
import { busIcon, busIconSize, busIconAnchor } from '@/utils/bus-icon';
import { Keys } from '/src/config.js';

export default {
  components: {
    GoogleMapLoader,
    VueElementLoading,
    Keys,
  },

  data() {
    return {
      // apiKey: Keys.GOOGLE_MAPS_API_KEY,
      // markers: [],
      // selectedIdx: null,
      // currentPlace: null,
      // on_route_trips: [],
      // directions: [],
      // polyline: [],
      // center: {
      //   lat: Keys.VUE_APP_ORIGIN_LAT,
      //   lng: Keys.VUE_APP_ORIGIN_LNG,
      // },
      // zoom: 12,
      // selectedItem: null,
      // submiting: false,
      // mode: null, //0: create, 1 edit
      isLoading: false,
      tileStyle: ['satellite', 'standard', 'esri', 'terrain'].includes(localStorage.getItem('mapTileStyle'))
        ? localStorage.getItem('mapTileStyle')
        : 'satellite',
      tileStyles: [
        { key: 'satellite', label: 'Satelit' },
        { key: 'standard',  label: 'Standard' },
        { key: 'esri',      label: 'Esri' },
        { key: 'terrain',   label: 'Terrain' },
      ],
      attribution:
        // '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        '',
      zoom: 12,
      center: [42.6526173, 21.1464795],
      markerLatLng: [42.6526173, 21.1464795],
      buses: [],
      bus_id: null,
      students: [],
      student_id: null,
      rides: [],
      busesLocation: [],
      // Id-te e udhetimeve qe serveri ia lejon ketij prindi.
      udhetimetELejuara: [],
      // Pozicioni i fundit i ditur, qe ekrani te mos mbetet bosh pa lidhje.
      offline: typeof navigator !== 'undefined' && navigator.onLine === false,
      lastSync: null,
      hasFitBounds: false,
      pollInterval: null,
    };
  },
  beforeDestroy() {
    window.removeEventListener('online', this.lidhjaUKthye);
    window.removeEventListener('offline', this.lidhjaURa);
    if (this.pollInterval) clearInterval(this.pollInterval);
  },

  mounted() {
    // Ankorat e markuesve. Jashte `data` qe te mos jene reaktive.
    this.ankorat = {};

    this.ngarkoNgaRuajtja();
    window.addEventListener('online', this.lidhjaUKthye);
    window.addEventListener('offline', this.lidhjaURa);
    // this.center.lat = parseFloat(this.center.lat);
    // this.center.lng = parseFloat(this.center.lng);
    // this.fetchOnRouteTrips();
    this.getAllStudents();
    this.getAllRides();
    this.getLocations();
    this.pollInterval = setInterval(() => { this.getRideBuses() }, 15000);
    this.getRideBuses();
    const map = this.$refs.mymap.mapObject;
    map.addControl(new window.L.Control.Fullscreen());
    map.removeControl(map.attributionControl);
    setTimeout(() => { map.invalidateSize(); }, 200);
  },
  computed: {
    url() {
      const tiles = {
        satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        standard:  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        esri:      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        terrain:   'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
      };
      return tiles[this.tileStyle] || tiles.satellite;
    },
  },
  methods: {
    /**
     * Pozicioni me te cilin lidhet shablloni — i pandryshueshem.
     *
     * Kthen gjithmone te njejtin varg per nje udhetim, ndaj vue2-leaflet nuk
     * e prek me markuesin pas krijimit dhe levizjen e zoteron `glideTo`.
     * Dyqani mbahet jashte `data`: po te ishte reaktiv, do te shkaktonte
     * riperpunim ne cdo kornize te animacionit.
     */
    ankora(location) {
      // Shablloni renderohet para `mounted`, ndaj dyqani krijohet ketu nese
      // ende nuk ekziston.
      if (!this.ankorat) this.ankorat = {};

      const id = location && location.ride ? location.ride.id : undefined;
      if (id === undefined) return location ? location.coordinates : undefined;

      if (!this.ankorat[id]) this.ankorat[id] = location.coordinates;
      return this.ankorat[id];
    },

    /** Celesi mban edhe perdoruesin: nje telefon mund te perdoret nga dy prinder. */
    celesiRuajtjes() {
      return 'buses_last_seen:' + (localStorage.getItem('userRole') || '') + ':' + (this.bus_id || 'all');
    },

    ruajPozicionet() {
      try {
        localStorage.setItem(this.celesiRuajtjes(), JSON.stringify({
          at: new Date().toISOString(),
          buses: this.busesLocation,
        }));
        this.lastSync = new Date().toISOString();
      } catch (e) {
        // Kujtesa e shfletuesit mund te jete plot; mungesa e ruajtjes nuk
        // duhet ta prishe ndjekjen live.
      }
    },

    ngarkoNgaRuajtja() {
      try {
        const raw = localStorage.getItem(this.celesiRuajtjes());
        if (!raw) return;
        const ruajtur = JSON.parse(raw);
        if (!Array.isArray(ruajtur.buses) || !ruajtur.buses.length) return;

        // Shfaqen vetem derisa te mberrije pergjigjja e pare e vertete.
        if (!this.busesLocation.length) this.busesLocation = ruajtur.buses;
        this.lastSync = ruajtur.at || null;
      } catch (e) {
        // Permbajtje e demtuar: thjesht nuk shfaqet asgje e ruajtur.
      }
    },

    lidhjaUKthye() {
      this.offline = false;
      this.getRideBuses();
    },

    lidhjaURa() {
      this.offline = true;
    },

    fitMapToBuses() {
      if (!this.busesLocation.length || this.hasFitBounds) return;
      this.hasFitBounds = true;
      const map = this.$refs.mymap?.mapObject;
      if (!map) return;
      const coords = this.busesLocation.map(l => l.coordinates);
      if (coords.length === 1) {
        map.setView(coords[0], 14);
      } else {
        map.fitBounds(coords, { padding: [50, 50], maxZoom: 14 });
      }
    },
    addBusIcon(on_route_trip) {
      const position = {
        lat: parseFloat(on_route_trip.last_position_lat),
        lng: parseFloat(on_route_trip.last_position_lng),
      };
      let infoText = this.getTripInfoText(on_route_trip);

      let marker = {
        place_id: on_route_trip.channel,
        position: position,
        infoText: infoText,
      };
      //change the marker icon to school bus
      const image = 'https://cdn-icons-png.flaticon.com/32/3471/3471521.png';
      marker.icon = image;
      this.markers.push(marker);
    },
    getTripInfoText(on_route_trip, speed = null) {
      let infoText = '';
      if (on_route_trip.driver) {
        infoText += '<b>Driver:</b> ' + on_route_trip.driver.name + '<br/>';
      }
      if (on_route_trip.trip && on_route_trip.trip.route) {
        infoText += '<b>Route:</b> ' + on_route_trip.trip.route.name + '<br/>';
      }
      if (speed) {
        infoText += '<b>Speed:</b> ' + speed + ' km/h<br/>';
      }
      return infoText;
    },
    //API Calls
    fetchOnRouteTrips() {
      this.submiting = true;
      axios
        .get('/planned-trips/on-route')
        .then((response) => {
          this.submiting = false;
          this.on_route_trips = response.data.running;
          if (this.on_route_trips.length > 0) {
            for (let index = 0; index < this.on_route_trips.length; index++) {
              this.addBusIcon(this.on_route_trips[index]);
            }
            this.listenToChannels();
          }
        })
        .catch(() => {
          this.submiting = false;
          this.$notify({
            title: 'Error',
            text: 'Error fetching on_route_trips of this route',
            type: 'error',
          });
          this.$router.go(-1);
          //this.$swal("Error", error.response.data.message, "error");
        });
    },
    listenToChannels() {
      for (let index = 0; index < this.on_route_trips.length; index++) {
        this.listenToChannel(index, this.on_route_trips[index]);
      }
    },
    listenToChannel(index, trip) {
      window.Echo.channel(trip.channel).listen('TripPositionUpdated', (e) => {
        if (this.selectedItem == trip.channel) {
          //update the marker position
          let data = e.data;
          //parse the data as json
          data = JSON.parse(data);
          let lat = data.lat;
          let lng = data.lng;
          //convert lat and lng to float if they are strings
          lat = parseFloat(lat);
          lng = parseFloat(lng);
          let speed = data.speed;
          //approximate the speed to 2 decimal places
          speed = Math.round(speed * 100) / 100;
          let position = {
            lat: lat,
            lng: lng,
          };
          let marker = this.markers[index];
          marker.position = position;
          let infoText = this.getTripInfoText(trip, speed);
          marker.infoText = infoText;
          this.center = position;
          this.selectedItem = null;
          //delay some time
          setTimeout(() => {
            this.selectedItem = trip.channel;
          }, 10);
        }
      });
    },
    getAllStudents() {
      axios
        .get('/users/guardian-students/list')
        .then((response) => {
          this.students = response?.data;
        })
        .catch((error) => {
          this.students = [];
          // Rifreskim ne sfond: pa njoftim. Perdoruesi nuk kerkoi asgje, dhe me
          // nje lidhje te dobet keto kuti grumbulloheshin cdo 15 sekonda.
          console.warn('Rifreskimi dështoi:', mesazhiIGabimit(error));
        });
    },
    getAllRides(student_id) {
      this.isLoading = true;
      axios
        .get('/rides/parent', { params: { student_id } })
        .then((response) => {
          this.rides = response?.data;
        })
        .catch((error) => {
          this.rides = [];
          // Rifreskim ne sfond: pa njoftim. Perdoruesi nuk kerkoi asgje, dhe me
          // nje lidhje te dobet keto kuti grumbulloheshin cdo 15 sekonda.
          console.warn('Rifreskimi dështoi:', mesazhiIGabimit(error));
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getLocations() {
      window.Echo.private(`bus-location`).listen('.location-updated', (e) => {
        // this.getRideBuses(this.student_id);

        if (!!this.bus_id && this.bus_id !== e.ride?.bus_id) {
          return;
        }

        // Kanali transmeton pozicionin e cdo autobusi ne sistem. Prindi sheh
        // vetem udhetimet qe ia lejon serveri; pa kete kontroll, ne harte
        // shfaqeshin edhe autobuset e femijeve te tjere.
        if (!this.udhetimetELejuara.includes(e.ride?.id)) {
          return;
        }

        const newRide = { ...e };
        newRide.coordinates = Object.values(newRide.coordinates);

        const index = this.busesLocation.findIndex(
          (item) => item.ride?.id === newRide.ride?.id
        );

        if (index !== -1) {
          this.busesLocation[index] = newRide;
        } else {
          this.busesLocation.push(newRide);
        }

        this.busesLocation = this.busesLocation.map((l) => {
          const lat = Number(l.coordinates[0]);
          const lng = Number(l.coordinates[1]);

          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            console.warn('Invalid coords for', l.ride.id, l.coordinates);
            return l;
          }

          return {
            ...l,
            coordinates: [lat, lng],
          };
        });

        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            glideTo(cmp?.mapObject, l.coordinates);
          }
          this.fitMapToBuses();
        });
      });
      window.Echo.private(`bus-location-refresh`).listen(
        '.location-refresh',
        (e) => {
          this.getRideBuses();
          this.getAllRides(this.bus_id);
        }
      );
    },
    getRideBuses(student_id) {
      // this.isLoading = true;
      axios
        .get('/rides/parent/buses', { params: { student_id } })
        .then((response) => {
          const rides = response?.data;

          // Udhetimet qe serveri i lejon per kete prind. Kanali i pozicioneve
          // eshte i perbashket per te gjithe autobuset e sistemit, ndaj vetem
          // keto id lejohen te dalin ne harte.
          this.udhetimetELejuara = (rides || []).map((r) => r.id);

          // Nje autobus mund te kete disa udhetime brenda dites. Shenja vendoset
          // ne pozicionin e tanishem te autobusit, ndaj udhetimet e perfunduara
          // do te jepnin disa shenja identike, njera mbi tjetren. Ne harte dalin
          // vetem ato qe jane ende ne rruge; lista majtas i mban te gjitha.
          const neRruge = (rides || []).filter((r) => !r.finished_at);

          this.busesLocation = this.busesLocation.filter((l) => neRruge.some((r) => r.id === l.ride?.id));
          if (neRruge.length > 0) {
            neRruge.map((ride) => {
              const location = {
                ride,
                coordinates: [
                  ride?.bus?.latitude ?? 42.6664358,
                  ride?.bus?.longitude ?? 21.1175278,
                ],
              };

              const index = this.busesLocation.findIndex(
                (item) => item?.ride?.id === location?.ride?.id
              );

              if (index !== -1) {
                this.busesLocation[index] = location;
              } else {
                this.busesLocation.push(location);
              }
            });
          } else {
            this.busesLocation = [];
          }

          this.busesLocation = this.busesLocation.map((l) => {
            const lat = Number(l.coordinates[0]);
            const lng = Number(l.coordinates[1]);

            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
              console.warn('Invalid coords for', l.ride.id, l.coordinates);
              return l;
            }

            return {
              ...l,
              coordinates: [lat, lng],
            };
          });

          // Pergjigje e vertete nga serveri: ruhet si pozicioni i fundit i
          // ditur, qe hera tjeter pa lidhje te mos nise me harte bosh.
          this.offline = false;
          this.ruajPozicionet();

          this.$nextTick(() => {
            for (const l of this.busesLocation) {
              const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
              glideTo(cmp?.mapObject, l.coordinates);
            }
          });
        })
        .catch((error) => {
          // Pa lidhje nuk ka kuptim nje njoftim gabimi ne cdo 15 sekonda:
          // shiriti lart e thote me qarte dhe nje here te vetme.
          if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            this.offline = true;
            return;
          }

          // Rifreskim ne sfond: pa njoftim. Perdoruesi nuk kerkoi asgje, dhe me
          // nje lidhje te dobet keto kuti grumbulloheshin cdo 15 sekonda.
          console.warn('Rifreskimi dështoi:', mesazhiIGabimit(error));
        })
        .then(() => {
          // this.isLoading = false;
        });
    },
    goToCenterLocation(coordinates) {
      this.$nextTick(() => {
        const map = this.$refs.mymap.mapObject;
        map.flyTo(coordinates, 13);
      });
    },
    busIcon,
    busIconSize,
    busIconAnchor,

    /** Numri ose emri i shkurter i autobusit, i shfaqur nen shenje. */
    busLabel(location) {
      const emri = location && location.ride && location.ride.bus && location.ride.bus.name;
      if (!emri) return '';
      // Vetem numri kur emri eshte si "Autobusi 3"; perndryshe tre shkronjat e para.
      const numri = String(emri).match(/\d+/);
      return numri ? numri[0] : String(emri).slice(0, 3);
    },
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
  },
  watch: {
    busesLocationVisible: {
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            this.$refs.mymap?.mapObject?.invalidateSize();
          });
        }
      },
    },
        tileStyle(val) { localStorage.setItem('mapTileStyle', val); },
    student_id: {
      handler: function (newVal, oldVal) {
        this.getAllRides(newVal);
      },
      deep: true,
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item i {
  cursor: pointer;
}

.v-application ul {
  padding-left: 12px !important;
}

.gm-style .gm-style-iw-d {
  color: #0d508b !important;
}
</style>

<style lang="scss">
.active-stop {
  background: rgba($primary-shade--light, 0.15) !important;
}

.scroll {
  overflow: scroll;
  scrollbar-gutter: stable;
}

.tracking-div {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.tracking-map {
  flex: 0 0 65%;
}

.tracking-rides {
  flex: 0 0 35%;
}

@media (max-width: 700px) {
  .tracking-div {
    flex-direction: column;
  }

  .tracking-map,
  .tracking-rides {
    flex: 0 0 100%;
  }
}

hr.divider {
  border-top: 1px solid #bbbb;
  border-radius: 25px;
  margin: 10px 7px;
  opacity: 0.5;
}

/* ── Page card header ── */
.pcard { border-radius: 14px !important; overflow: hidden; border: none !important; }
.pcard-header {
  padding: 10px 16px;
  display: flex; align-items: center; justify-content: space-between;
}
.pcard--orange .pcard-header { background: linear-gradient(135deg, #BF360C, #FF8F00); }
.pcard-header-left { display: flex; align-items: center; gap: 10px; }
.pcard-icon-wrap {
  width: 32px; height: 32px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
}
.pcard-header-sub {
  font-size: 11px; color: #fff !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0; font-weight: 600; opacity: 0.88;
}
.pcard-header-title { font-size: 16px; font-weight: 800; color: #fff !important; margin: 0; line-height: 1.2; }

/* Ne telefon titulli dhe mbititulli rrine ne nje rresht: shiriti mbetet i
   holle dhe harta nis me lart. */
@media (max-width: 700px) {
  .pcard-header { padding: 8px 12px; }
  .pcard-header-left { gap: 8px; }
  .pcard-icon-wrap { width: 28px; height: 28px; border-radius: 7px; }
  .pcard-header-sub { display: none; }
  .pcard-header-title { font-size: 15px; }
}

/* ── Ride cards ── */
.ride-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 32px 16px; text-align: center;
}
.ride-empty-text { color: #94a3b8; font-size: 14px; margin-top: 8px; }

.ride-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.07);
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.ride-card-header {
  display: flex; align-items: center; gap: 10px; margin-bottom: 8px;
}
.ride-card-bus-name { font-size: 14px; font-weight: 700; color: #1a2744; }
.ride-card-row {
  display: flex; align-items: center; gap: 10px; margin-bottom: 6px;
}
.ride-card-icon {
  width: 28px; height: 28px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ride-icon-orange { background: rgba(230,81,0,0.1); }
.ride-icon-blue   { background: rgba(25,118,210,0.1); }
.ride-icon-green  { background: rgba(56,142,60,0.1); }
.ride-icon-teal   { background: rgba(0,131,143,0.1); }
.ride-icon-red    { background: rgba(211,47,47,0.1); }
.ride-card-text { font-size: 13px; color: #374151; }
.ride-card-text--muted { color: #64748b; }

.tile-selector {
  display: flex;
  gap: 6px;
  margin: 8px 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.tile-selector::-webkit-scrollbar { display: none; }
.tile-btn {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1.5px solid #ccc;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #444;
  white-space: nowrap;
  flex-shrink: 0;
}
.tile-btn:hover { border-color: #F57C00; color: #F57C00; }
.tile-btn.active { background: #F57C00; color: #fff; border-color: #F57C00; }

.tracking-map .leaflet-container { touch-action: none; z-index: 0; isolation: isolate; }
.no-trip-msg { text-align: center; padding: 32px 16px; color: #94a3b8; }
.no-trip-msg p { margin-top: 8px; font-size: 13px; }
.leaflet-control-attribution { display: none !important; }
</style>